import types from './types'
import api from '@/api'
import appConfig from '@/config'

const actions = {
  /**
   * 中台用户登录
   * @param {string} username
   * @param {string} password
   */
  [types.ADMIN_LOGIN] ({commit}, {username, password, verificationCode}) {
    return api('base/login', {loginName: username, password, verificationCode}, true)().then(res => {
      commit(types.SET_USER, res)
    })
  },
  /**
   * 中台用户首次登录重设密码
   * @param {string} oldPwd     原密码
   * @param {string} accountPwd 新密码
   */
  [types.RESET_PASSWORD] ({commit}, {oldPwd, accountPwd}) {
    return api('base/updatePassword', {oldPwd, accountPwd}, true)().then(res => {
      commit(types.SET_USER, res)
    })
  },
  /**
   * 拉取当前用户信息
   */
  [types.GET_USER_INFO] ({commit}) {
    return api('base/getCurrentUser', {}, true)().then(res => {
      commit(types.SET_USER, res);
      commit(types.SET_MENU_LIST, res[appConfig.router.menusKey])
      return res
    })
  },
  [types.LOGOUT] ({commit}) {
    return api('base/logout')().then(() => {
      // setTimeout(() => {
      commit(types.SET_USER, {})
      setTimeout(() => {commit(types.CLEAR_MENUS)}, 1000)
      // }, 500)
    }).catch(() => { // 错误，正常来说不会这样
      // commit(types.SET_USER, {})
      // commit(types.CLEAR_MENUS)
    })
  }
}

export default actions



// WEBPACK FOOTER //
// ./src/store/module/user/actions.js